import styled from 'styled-components';

export const ParticlesSectionContainer = styled.div`
    width: 100%;
    height: 100%;
`;